import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { stocksService } from "services/stock.api";
import { selectStockItems } from "store/stockSlice";
import { setStockItems } from "store/stockSlice";

const useStock = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const stockList = useSelector(selectStockItems);
  const [error, setError] = useState(null);

  const getstockList = async (data) => {
    setLoading(true);
    try {
      const response = await stocksService.fetchList(data);
      if (response.success) {
        dispatch(setStockItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const stockPreview = async (payload) => {
    setLoading(true);
    try {
      const response = await stocksService.previewStocks(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const stockSync = async (payload) => {
    setLoading(true);
    try {
      const response = await stocksService.syncStocks(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  return {
    getstockList,
    stockList,
    stockPreview,
    stockSync,
    loading,
    error,
  };
};

export default useStock;
